import Vue from 'vue'

import rowCell from './action-row-cell'
Vue.component(rowCell.name, rowCell)

export default {
    slots() {
        return [
            {
                slot: "row-cell",
                component: rowCell.name,
                condition(attrs) {
                    let enabled = attrs.col.type === 'ActionColumn'

                    if( enabled ) {
                        attrs.col.denyCellClick = true
                    }

                    return enabled
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayActionColumn: {
                    type: Boolean,
                    default: true
                },
                actions: {
                    type: [Array, Function],
                    default: () => []
                },
                actionsType: {
                    type: String,
                    default: 'inline',
                    validator: function (value) {
                        return ['inline', 'dropdown'].indexOf(value) !== -1
                    }
                },
                actionsDropdownAttrs: {
                    type: Object,
                    default: () => ({})
                },
                onRowClickAction: {
                    type: [String, Number, Boolean],
                    default: 0
                }
            },
            created() {
                if( this.displayActionColumn && false !== this.onRowClickAction ) {
                    this.defaultOnRowClick = (row, col, index) => {
                        let actions = typeOf( this.actions ) === 'function'
                            ? this.actions(row, col, index)
                            : this.actions

                        let actionIndex = Number(this.onRowClickAction)

                        if( actions[actionIndex] === undefined ) {
                            console.error('Table plguin [ActionColumn]: Invalid action index('+actionIndex+') given in "onRowClickAction" param.')
                        }

                        if( actions[actionIndex].onClick !== undefined ) {
                            actions[actionIndex].onClick(row)
                        }
                    }
                }
            }
        }
    }
}
